// src/pages/Users/Techniques/ui/FilterField.jsx

import React from "react";
import { FaChevronDown } from "react-icons/fa";

export default function FilterField({
  icon: Icon,
  label,
  value,
  options = [],
  onChange,
}) {
  return (
    <label className="group block rounded-[1.35rem] border border-slate-200 bg-slate-50 p-3 transition hover:border-sky-300 hover:bg-white dark:border-slate-800 dark:bg-slate-950 dark:hover:border-sky-800 dark:hover:bg-slate-900">
      <span className="mb-2 flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.16em] text-slate-400">
        {Icon ? (
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-white text-sky-600 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:text-sky-300 dark:ring-slate-700">
            <Icon />
          </span>
        ) : null}

        {label}
      </span>

      <div className="relative">
        <select
          value={value}
          onChange={(event) =>
            onChange(event.target.value)
          }
          className="h-11 w-full appearance-none rounded-xl border border-slate-200 bg-white pl-3 pr-10 text-sm font-bold text-slate-800 outline-none transition focus:border-sky-400 focus:ring-4 focus:ring-sky-400/10 dark:border-slate-700 dark:bg-slate-900 dark:text-white"
        >
          {options.map((option) => {
            const optionValue =
              typeof option === "string"
                ? option
                : option.value;

            const optionLabel =
              typeof option === "string"
                ? option
                : option.label;

            return (
              <option
                key={optionValue}
                value={optionValue}
              >
                {optionLabel}
              </option>
            );
          })}
        </select>

        <FaChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-400" />
      </div>
    </label>
  );
}